import { useState, useEffect, useRef } from 'react';
import { buscarOraculo, marcarOraculoVisto } from '../utils/oraculos';
import OracleShareCard from './OracleShareCard';

// ── SVG Icons ────────────────────────────────────────────────
const HeartIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
);
const BriefcaseIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2"/>
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
    <line x1="12" y1="12" x2="12" y2="12"/>
  </svg>
);
const HomeIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z"/>
    <polyline points="9 21 9 13 15 13 15 21"/>
  </svg>
);
const LeafIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 8C8 10 5.9 16.17 3.82 19.3a1 1 0 0 0 1.42 1.4C8 18 12 17 15 14"/>
    <path d="M17 8c0 0 0 8-8 11"/>
    <path d="M17 8c2-2 3-5 2-8-3 1-6 3-7 8"/>
  </svg>
);
const CoinsIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="8" cy="8" r="6"/>
    <path d="M18.09 10.37A6 6 0 1 1 10.34 18"/>
    <path d="M7 6h1v4"/>
    <line x1="16.71" y1="13.88" x2="13.38" y2="20.72"/>
  </svg>
);
const StarFourIcon = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2 L13.8 10.2 L22 12 L13.8 13.8 L12 22 L10.2 13.8 L2 12 L10.2 10.2 Z"/>
  </svg>
);
const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);
const ShareIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3"/>
    <circle cx="6" cy="12" r="3"/>
    <circle cx="18" cy="19" r="3"/>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
  </svg>
);

// ── Áreas da vida ────────────────────────────────────────────
const AREAS = [
  { id: 'amor',            label: 'Amor & Relacionamentos',    icon: <HeartIcon /> },
  { id: 'trabalho',        label: 'Trabalho & Propósito',      icon: <BriefcaseIcon /> },
  { id: 'familia',         label: 'Família & Raízes',          icon: <HomeIcon /> },
  { id: 'autocuidado',     label: 'Autocuidado & Saúde',       icon: <LeafIcon /> },
  { id: 'financas',        label: 'Finanças & Abundância',     icon: <CoinsIcon /> },
  { id: 'espiritualidade', label: 'Espiritualidade & Intuição',icon: <StarFourIcon /> },
];

// ── Telas ────────────────────────────────────────────────────
// 'welcome' → 'areas' → 'loading' → 'reveal'

export default function OracleModal({ onClose, userName, onReceberOraculo }) {
  const [tela, setTela] = useState('welcome');
  const [areaSelecionada, setAreaSelecionada] = useState(null);
  const [oraculo, setOraculo] = useState('');
  const [visible, setVisible] = useState(false);
  const [sharing, setSharing] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [shareError, setShareError] = useState(false);
  const [avisoSaida, setAvisoSaida] = useState(false);
  const [checkinRegistrado, setCheckinRegistrado] = useState(false);

  const shareCardRef = useRef(null);

  // fade-in ao montar
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 30);
    return () => clearTimeout(t);
  }, []);

  // Fecha o modal de verdade (sem aviso)
  const fecharDefinitivo = () => {
    setVisible(false);
    setTimeout(() => {
      marcarOraculoVisto();
      onClose();
    }, 300);
  };

  // Tentar fechar: nas telas 1-2 mostra aviso de check-in; nas outras fecha direto
  const fechar = () => {
    if (tela === 'welcome' || tela === 'areas') {
      setAvisoSaida(true);
      return;
    }
    fecharDefinitivo();
  };

  // Registra o check-in (chamado pelos botões do reveal — só uma vez)
  const registrarCheckin = () => {
    if (!checkinRegistrado && onReceberOraculo) {
      onReceberOraculo();
      setCheckinRegistrado(true);
    }
  };

  const selecionarArea = async (area) => {
    setAreaSelecionada(area);
    setTela('loading');

    const { frase } = await buscarOraculo(area.id);
    // garante ao menos 1.5s de animação
    await new Promise(r => setTimeout(r, 1500));
    setOraculo(frase);
    setTela('reveal');
  };

  const handleCompartilhar = async () => {
    if (!shareCardRef.current || sharing) return;
    registrarCheckin(); // compartilhar = check-in
    setSharing(true);
    setShareError(false);
    try {
      const html2canvas = (await import('html2canvas')).default;
      const canvas = await html2canvas(shareCardRef.current, {
        scale: 3,
        useCORS: true,
        backgroundColor: null,
        logging: false,
      });
      setPreviewUrl(canvas.toDataURL('image/png'));
    } catch (err) {
      console.error('[Oracle] html2canvas error:', err);
      // Fallback: compartilhar texto via blob quando html2canvas falha
      try {
        const texto = `"${oraculo}"\n\n— ${areaSelecionada?.label} | Clube do Eu`;
        const blob = new Blob([texto], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        if (navigator.canShare && navigator.canShare()) {
          await navigator.share({ text: texto, title: 'Oráculo do dia — Clube do Eu' });
        } else {
          const link = document.createElement('a');
          link.href = url;
          link.download = 'oraculo-do-dia.txt';
          link.click();
        }
        URL.revokeObjectURL(url);
      } catch {
        setShareError(true);
      }
    } finally {
      setSharing(false);
    }
  };

  const handleDownload = () => {
    if (!previewUrl) return;
    const link = document.createElement('a');
    link.download = 'oraculo-do-dia.png';
    link.href = previewUrl;
    link.click();
  };

  const handleShare = async () => {
    if (!previewUrl) return;
    try {
      const res = await fetch(previewUrl);
      const blob = await res.blob();
      const file = new File([blob], 'oraculo-do-dia.png', { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: 'Meu oráculo do dia — Clube do Eu' });
      } else {
        handleDownload();
      }
    } catch {
      handleDownload();
    }
  };

  return (
    // translate="no" evita que o Google Translate mute os nós de texto e quebre o React
    <div translate="no">
      {/* Card oculto — capturado como imagem ao compartilhar */}
      <div style={{ position: 'fixed', top: '-9999px', left: '-9999px', pointerEvents: 'none' }}>
        <OracleShareCard ref={shareCardRef} frase={oraculo} area={areaSelecionada} />
      </div>

      {/* Preview da imagem gerada */}
      {previewUrl && (
        <div className="oracle-preview-backdrop" onClick={() => setPreviewUrl(null)}>
          <div className="oracle-preview-box" onClick={e => e.stopPropagation()}>
            <img
              src={previewUrl}
              alt="Oráculo do dia"
              className="oracle-preview-img"
              draggable={false}
            />
            <button
              className="btn btn-primary"
              style={{ width: '100%' }}
              onClick={handleShare}
            >
              Compartilhar / Salvar imagem
            </button>
            <button
              className="btn btn-ghost oracle-preview-close"
              onClick={() => setPreviewUrl(null)}
            >
              Fechar
            </button>
          </div>
        </div>
      )}

      <div className={`oracle-backdrop ${visible ? 'visible' : ''}`} onClick={e => e.target === e.currentTarget && fechar()}>
        <div className={`oracle-card ${visible ? 'visible' : ''}`}>

          {/* Botão fechar — só nas telas 1 e 2; loading e reveal não têm X */}
          {(tela === 'welcome' || tela === 'areas') && (
            <button className="oracle-close" onClick={fechar} aria-label="Fechar">
              <CloseIcon />
            </button>
          )}

          {/* ── AVISO DE SAÍDA (telas 1 e 2) ── */}
          {avisoSaida && (
            <div className="oracle-aviso-saida">
              <p className="oracle-aviso-texto">
                Se sair agora, o check-in do dia não será registrado.
              </p>
              <div className="oracle-aviso-acoes">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => setAvisoSaida(false)}
                >
                  Ficar
                </button>
                <button
                  className="btn btn-ghost btn-sm"
                  onClick={fecharDefinitivo}
                >
                  Sair mesmo assim
                </button>
              </div>
            </div>
          )}

          {/* ── TELA 1: Boas-vindas ── */}
          {tela === 'welcome' && (
            <div className="oracle-screen">
              <div className="oracle-star-wrap">
                <StarFourIcon size={36} />
              </div>
              <h2 className="oracle-title">
                O universo tem uma mensagem para você hoje
              </h2>
              <p className="oracle-subtitle">
                Escolha uma área da sua vida e receba seu oráculo do dia.
              </p>
              <button className="btn btn-primary oracle-cta" onClick={() => setTela('areas')}>
                Receber minha mensagem
              </button>
            </div>
          )}

          {/* ── TELA 2: Seleção de área ── */}
          {tela === 'areas' && (
            <div className="oracle-screen">
              <h2 className="oracle-title">Qual área da sua vida<br />pede atenção hoje?</h2>
              <div className="oracle-areas-grid">
                {AREAS.map(area => (
                  <button
                    key={area.id}
                    className="oracle-area-btn"
                    onClick={() => selecionarArea(area)}
                  >
                    <span className="oracle-area-icon">{area.icon}</span>
                    <span className="oracle-area-label">{area.label}</span>
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* ── TELA 3: Loading / Animação ── */}
          {tela === 'loading' && (
            <div className="oracle-screen oracle-screen-loading">
              <div className="oracle-loading-ring">
                <div className="oracle-loading-inner">
                  <StarFourIcon size={32} />
                </div>
              </div>
              <p className="oracle-loading-label">Preparando seu oráculo...</p>
              {areaSelecionada && (
                <p className="oracle-loading-area">{areaSelecionada.label}</p>
              )}
            </div>
          )}

          {/* ── TELA 4: Revelação ── sem X; ambos botões = check-in ── */}
          {tela === 'reveal' && (
            <div className="oracle-screen oracle-screen-reveal">
              <div className="oracle-reveal-tag">
                <StarFourIcon size={10} />
                {areaSelecionada?.label}
              </div>
              <blockquote className="oracle-frase">
                "{oraculo}"
              </blockquote>
              <button
                className="btn btn-primary oracle-cta oracle-share-btn"
                onClick={handleCompartilhar}
                disabled={sharing}
              >
                <ShareIcon />
                {sharing ? 'Gerando imagem...' : 'Compartilhar'}
              </button>
              {shareError && (
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: 'var(--blush)', textAlign: 'center', marginTop: 8 }}>
                  Não foi possível gerar a imagem. Tente novamente.
                </p>
              )}
              <button
                className="btn btn-ghost oracle-cta"
                onClick={() => { registrarCheckin(); fecharDefinitivo(); }}
              >
                Guardar no coração
              </button>
              <button className="btn btn-ghost oracle-skip" onClick={() => setTela('areas')}>
                Escolher outra área
              </button>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
